import { Box, Grid, Stack, styled, Typography, Toolbar } from '@mui/material';
import { Colors } from 'app/constants/color';

const Container = styled(Box)({
  height: '100vh',
  width: '100vw',
});

const ParentGrid = styled(Grid)({
  height: '100%',
  width: '100%',
});

const ChildGrid = styled(Grid)({
  height: '100%',
  width: '50%',
  // background: 'linear-gradient(89.71deg, #C697DF 0.21%, #DEB88F 31.47%, #C472B2 103.7%)',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  flexDirection: 'column',
});

const QrImageContainer = styled(Box)({
  width: '350px',
  height: '350px',
  margin: '5px',
});

const CustomizedToolbar = styled(Toolbar)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: 0,
});

const IconsDiv = styled(Box)({
  width: '99.5%',
  display: 'flex',
  // flexDirection: 'row',
  alignItems: 'center',
  // justifyContent: 'right',
  justifyContent: 'space-between',
});

const ChildGrid2 = styled(Grid)({
  height: '100%',
  width: '50%',
  padding: '0 0 3% 2%',
});

const LanguageSelectorContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'right',
  alignItems: 'center',
  height: '15%',
});

const CustomHeading1 = styled(Typography)({
  fontWeight: 700,
  color: Colors.primary,
  fontSize: '2em',
  lineHeight: '40px',
});

const CustomHeading2 = styled(Typography)({
  fontWeight: 700,
  color: ' rgb(8,23,53)',
  fontSize: '2em',
  lineHeight: '40px',
});

const ImgContainer = styled(Box)({
  width: '100%',
  // height: '50%',
  // marginTop: '30px',
});

const ImageContainer = styled(Box)({
  width: '32%',
  height: '50%',
});

const ImgText = styled(Typography)({
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  color: '#081735',
  marginTop: '0px',
  width: '100%',
  textAlign: 'center',
});

const ButtonContainer = styled(Box)({
  width: '100%',
  marginTop: '2vh',
});

const FooterLogoContainer = styled(Box)({
  width: '50%',
  // marginTop: '22%',
  position: 'absolute',
  bottom: '3%',
});

const FooterText = styled(Typography)({
  fontWeight: '400',
  fontSize: '0.8em',
  lineHeight: '20px',
  color: Colors.text_icon,
});

const FooterStack = styled(Stack)({
  // marginTop:'10px'
});

const ChildGridImageContainer = styled(Box)({
  height: '40%',
  width: '45%',
  marginTop: '10vh',
  display: 'flex',
  alignItems: 'center',
});

const ChildGridTextContainer = styled(Box)({
  height: '25%',
  width: '51%',
});

const Heading = styled(Typography)({
  fontWeight: '700',
  fontSize: '1.7em',
  textAlign: 'center',
  lineHeight: '45px',
  color: '#FFFFFF',
});

const Description = styled(Typography)({
  textAlign: 'center',
  lineHeight: '20px',
  fontWeight: '400',
  fontSize: '0.8em',
  color: '#FFFFFF',
  marginTop: '10px',
});

// const QrImageContainer = styled(Box)({
//   width: '260px',
//   height: '260px',
//   margin: 0,
// });

const SimpleImageContainer = styled(Box)({
  width: '350px',
  height: '350px',
  margin: '5px',
});

export {
  Container,
  ParentGrid,
  ChildGrid,
  ChildGrid2,
  LanguageSelectorContainer,
  CustomHeading1,
  CustomHeading2,
  ImgContainer,
  ImageContainer,
  ImgText,
  ButtonContainer,
  FooterLogoContainer,
  FooterText,
  FooterStack,
  ChildGridImageContainer,
  ChildGridTextContainer,
  Heading,
  Description,
  QrImageContainer,
  SimpleImageContainer,
  CustomizedToolbar,
  IconsDiv,
};
